<template>
  <div class="contents">
    <zangyouList :isLoading="isLoading" :isError="isError" :isInit="isInit" :dataList="shinseiList" />
  </div>
  <!--contents-->
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useShinseiList } from "@/composable/shinsei/list/list";
import ZangyouList from "@/components/shinsei/list/parts/ZangyouList.vue";
import { useShinseiStore } from "@/store/shinsei";
import ShinseiOptionConst from '@/const/Shinsei/Option';

export default defineComponent({
  setup() {
    // 初期化
    const { getShinseiList, isLoading, isError, shinseiList } = useShinseiList();
    const shinseiStore = useShinseiStore();
    const isInit = ref(false);

    // 初期取得
    onMounted(async () => {
      // 残業申請から遷移してきた場合

      shinseiStore.item.searchStatus = ShinseiOptionConst.SEARCH_STATUS.ZANGYOU
      // 残業申請情報取得
      await getShinseiList(shinseiStore.item);

      isInit.value = true;
    });

    return {
      isLoading,
      isError,
      shinseiList,
      isInit,
    };
  },
  components: {
    zangyouList: ZangyouList,
  },
});
</script>
